import axios from 'axios';

const reopenReminder = (id, payload) => {
  return axios
    .post(`${process.env.REACT_APP_API_URL}/api/reminder/${id}/reopen`, payload)
    .then(res => res)
    .catch(err => err);
};

export default reopenReminder;
